module.exports = __webpack_public_path__ + "img/Vine_tours.8fd1bd89.jpg";